const todo = () => {
    alert('todo')
}

export {
    todo
}